module.exports = __webpack_public_path__ + "static/bill-5ce036f1cce9c892f245b99541635bd7.png";